import RemuneracaoMedicaInterceptor from '@finx/web-repository/src/apis/RemuneracaoMedica/RemuneracaoMedicaInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new RemuneracaoMedicaInterceptor()

export default {
  async getPrestadorRecebimentoAll(params: any) {
    let query: string = ''

    if (params.nome) {
      query = `&nome=${params.nome}`
    }

    if (params.fontePagadoraId) {
      query += `&fontePagadoraId=${params.fontePagadoraId}`
    }

    if (params.pagina) {
      query += `&pagina=${params.pagina}`
    }

    if (params.qtdPorPagina) {
      query += `&qtdPorPagina=${params.qtdPorPagina}`
    }

    if (params.grupoRepasse) {
      query += `&grupoRepasse=${params.grupoRepasse}`
    }

    if (params.valornota) {
      query += `&valornota=${params.valornota}`
    }

    if (params.numeroNota) {
      query += `&numeroNota=${params.numeroNota}`
    }

    if (params.contasPagar) {
      query += `&contasPagar=${params.contasPagar}`
    }

    if (params.numeroChamado) {
      query += `&numeroChamado=${params.numeroChamado}`
    }

    if (params.anoMesReferencia) {
      query += `&anoMesReferencia=${params.anoMesReferencia}`
    }

    if (params.sortBy) {
      query += `&sortBy=${params.sortBy}`
    }

    if (params.numeroRepasse) {
      query += `&numeroRepasse=${params.numeroRepasse}`
    }

    if (params.situacoes.length > 0) {
      const situacao = `&situacao=${params.situacoes.join('&situacao=')}`
      query += `${situacao}`
    }

    if(params.profissionalId){
      query += `&profissionalId=${params.profissionalId}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`recebimento/prestadorrecebimentos?${query}`)
    return factory.build(request)
  },

  async atualizarNotaFiscal(params: any) {
    const request = await api.put(`recebimento/${params.prestadorRecebimentoId}`, params)
    return factory.build(request)
  },

  async getTiposCarga() {
    const request = await api.get('recebimento/listagem-enum/TipoImportacaoEnum')
    return factory.build(request)
  },

  async getItemsMonitoramentoCargas(params: any) {
    let query: string = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.tipoEnum) query += `&tipoEnum=${params.tipoEnum}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`recebimento${query}`)
    return factory.build(request)
  },

  async getTipoFilter() {
    const request = await api.get('recebimento/listagem-enum/RecebimentoTipo')
    return factory.build(request)
  },

  async getTiposCargaDownload() {
    const request = await api.get('recebimento/listagem-enum/TipoLayoutCarga')
    return factory.build(request)
  },

  async deletarNotaFiscal(prestadorRecebimentoId: string) {
    const request = await api.delete(`recebimento/${prestadorRecebimentoId}/nota-fiscal`)
    return factory.build(request)
  },

  async deletarRepasse(prestadorRecebimentoId: string) {
    const request = await api.delete(`recebimento/${prestadorRecebimentoId}`)
    return factory.build(request)
  },

  async geRecebimentoById(id: string) {
    const request = await api.get(`recebimento/${id}`)
    return factory.build(request)
  },

  async getRecebimentoNotaFiscalById(id: string) {
    const request = await api.get(`recebimento/prestadorrecebimentos/${id}/nota-fiscal`)
    return factory.build(request)
  },

  async getLogs() {
    const request = await api.get('recebimento/carga-logs')
    return factory.build(request)
  },

  async sendEmailCobrancaNotaFiscal(params: any) {
    const request = await api.post('recebimento/enviar-email-cobranca-nota-fiscal', params)
    return factory.build(request)
  },

  async provisionarRemuneracao(params: any) {
    const request = await api.post('recebimento/provisionar-recebimento', params)
    return factory.build(request)
  },

  async deleteNotaFiscal(params: any) {
    const request = await api.delete(`recebimento/${params.prestadorRecebimentoId}/nota-fiscal?documentoId=${params.documentoId}`)
    return factory.build(request)
  },

  async cancelarProvisionamentoRemuneracao(params: any) {
    const request = await api.post('recebimento/cancelar-provisionamento-recebimento', params)
    return factory.build(request)
  },

  async notificarManualmenteRecebimento(params: any) {
    const request = await api.post('recebimento/notificar-manualmente', params)
    return factory.build(request)
  },

  async getFontePagadoraAll() {
    const request = await api.get('recebimento/fontes-pagadoras')
    return factory.build(request)
  },

  async getTipoList() {
    const request = await api.get('recebimento/listagem-enum/NotificacaoEmailConfiguracaoTipo')
    return factory.build(request)
  },

  async getLayoutEmailList() {
    const request = await api.get('recebimento/notificacao-config')
    return factory.build(request)
  },

  async getLayoutEmailById(params: any) {
    const request = await api.get(`recebimento/notificacao-config/${params.hospitalId}?Tipo=${params.tipoNome}`)
    return factory.build(request)
  },

  async salvarLayoutEmail(params: any) {
    const request = await api.put('recebimento/notificacao-config', params)
    return factory.build(request)
  },

  async getAllProcedimentosRecalculo(params: any) {
    let query: string = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.fontePagadoraId) query += `&fontePagadoraId=${params.fontePagadoraId}`
    if (params.mesAnoCompetencia) query += `&mesAnoCompetencia=${params.mesAnoCompetencia}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`calculo/geracao-repasses/procedimentos${query}`)
    return factory.build(request)
  },

  async getTipoItens() {
    const request = await api.get('recebimento/medico-recebimento-tipo')
    return factory.build(request)
  },

  async getGerarRepassePrestadores(param: any) {
    const request = await api.get(`calculo/geracao-repasses/${param}/pessoa-prestador`)
    return factory.build(request)
  },

  async getStatusList() {
    const request = await api.get('recebimento/listagem-enum/StatusPrestadorRecebimentoEnum')
    return factory.build(request)
  },

  async getRelatoriosAreaEnum() {
    const request = await api.get('recebimento/listagem-enum/RelatorioAreaEnum')
    return factory.build(request)
  },

  async getItemsMonitorIntegracao(params: any) {
    let query: string = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`recebimento/log-integracao${query}`)
    return factory.build(request)
  },

  async gerarRepasses(params: any) {
    const request = await api.put('calculo/geracao-repasses', params)
    return factory.build(request)
  },

  async getCondicaoPagamento() {
    const request = await api.get('recebimento/condicao-pagamento')
    return factory.build(request)
  },

  async getGeracaoRepasse(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.estabelecimentoId) query += `&estabelecimentoId=${params.estabelecimentoId}`
    if (params.mesAnoCompetencia) query += `&mesAnoCompetencia=${params.mesAnoCompetencia}`
    if (params.profissionalId) query += `&profissionalId=${params.profissionalId}`
    if (params.prestadorId) query += `&prestadorId=${params.prestadorId}`

    if (params.status.length > 0) {
      const situacao = `&status=${params.status.join('&status=')}`
      query += `${situacao}`
    }

    if (params.tipo.length > 0) {
      const tipo = `&tipo=${params.tipo.join('&tipo=')}`
      query += `${tipo}`
    }

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`calculo/geracao-repasses${query}`)
    return factory.build(request)
  },

  async getGeracaoDeRepassesItemsVisualizar(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.prestadorId) query += `&prestadorId=${params.prestadorId}`

    if (params.statusRepasse && params.statusRepasse.length > 0) {
      const situacao = `&statusRepasse=${params.statusRepasse.join('&statusRepasse=')}`
      query += `${situacao}`
    }

    if(params.profissionalId){
      query += `&profissionalId=${params.profissionalId}`
    }

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`calculo/geracao-repasses/${params.id}/prestador-recebimentos${query}`)
    return factory.build(request)
  },

  async getPrestadorRecebimentoDescontos(params: any) {
    const request = await api.get(`calculo/geracao-repasses/${params.geracaoRepasseId}/prestador-recebimentos/${params.prestadorRecebimentoId}/descontos`)
    return factory.build(request)
  },

  async getCargasVisualizarItems(params: any) {
    const request = await api.get(`recebimento/calculo/geracao-repasse-carga-item/${params.id}`)
    return factory.build(request)
  },

  async getProcedimentosDescarteRecriacao(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.prestadorId) query += `&PrestadorId=${params.prestadorId}`
    if (params.identificadorHis) query += `&IdentificadorHis=${params.identificadorHis}`
    if (params.numeroAtendimento) query += `&NumeroAtendimento=${params.numeroAtendimento}`
    if (params.codigo) query += `&Codigo=${params.codigo}`
    if (params.profissionalExecutanteId) query += `&ProfissionalExecutanteId=${params.profissionalExecutanteId}`
    if (params.dataExecucaoDe) query += `&DataExecucaoDe=${params.dataExecucaoDe}`
    if (params.dataExecucaoAte) query += `&DataExecucaoAte=${params.dataExecucaoAte}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`calculo/geracao-repasses/${params.id}/procedimentos-descartados${query}`)
    return factory.build(request)
  },

  async getProcedimentosDescartados(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.prestadorId) query += `&prestadorId=${params.prestadorId}`
    if (params.identificadorHis) query += `&identificadorHis=${params.identificadorHis}`
    if (params.numeroAtendimento) query += `&numeroAtendimento=${params.numeroAtendimento}`
    if (params.codigo) query += `&codigo=${params.codigo}`
    if (params.profissionalExecutanteId) query += `&profissionalExecutanteId=${params.profissionalExecutanteId}`
    if (params.operadoraId) query += `&operadoraId=${params.operadoraId}`
    if (params.dataExecucaoDe) query += `&dataExecucaoDe=${params.dataExecucaoDe}`
    if (params.dataExecucaoAte) query += `&dataExecucaoAte=${params.dataExecucaoAte}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`calculo/geracao-repasses/${params.id}/procedimentos-descartados${query}`)
    return factory.build(request)
  },

  async alterarFuncaoGeracaoRepasse(params: any) {
    const request = await api.put(`producao/producao-procedimento/altera-funcao/${params.novaFuncao}`, params)
    return factory.build(request)
  },

  async getGeracaoDeRepasseItensPrestador(params: any) {
    const { id, prestadorRecebimentoId } = params

    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.apenasDivergente) query += `&apenasDivergente=${params.apenasDivergente}`
    if (params.codigo) query += `&codigo=${params.codigo}`
    if (params.numeroAtendimento) query += `&numeroAtendimento=${params.numeroAtendimento}`
    if (params.operadoraId) query += `&operadoraId=${params.operadoraId}`
    if (params.dataExecucaoDe) query += `&dataExecucaoDe=${params.dataExecucaoDe}`
    if (params.dataExecucaoAte) query += `&dataExecucaoAte=${params.dataExecucaoAte}`
    if (params.profissionalId) query += `&profissionalId=${params.profissionalId}`
    if (params.tipo) query += `&tipo=${params.tipo}`
    if (params.turno) query += `&Turno=${params.turno}`

    if (params.funcoes.length > 0) {
      const funcoes = `&funcoes=${params.funcoes.join('&funcoes=')}`
      query += `${funcoes}`
    }

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`calculo/geracao-repasses/${id}/prestador-recebimentos/${prestadorRecebimentoId}/itens${query}`)
    return factory.build(request)
  },

  async getPrestadorRecebimentoLogs(params: any) {
    const { geracaoRepasseId, prestadorRecebimentoId } = params
    const request = await api.get(`calculo/geracao-repasses/${geracaoRepasseId}/prestador-recebimentos/${prestadorRecebimentoId}/logs`)
    return factory.build(request)
  },

  async getAllDescontosPrestador(params: any) {
    const request = await api.get(`recebimento/calculo/prestador/${params.prestadorId}/descontos`)
    return factory.build(request)
  },

  async getPontuacaoProfissional() {
    const request = await api.get('calculo/pontuacao')
    return factory.build(request)
  },

  async getProfissionalPontuacao(params: any) {
    const { profissionalId } = params
    const query: string = `profissionalId=${profissionalId}`
    const request = await api.get(`calculo/pontuacao-profissional?${query}`)
    return factory.build(request)
  },

  async getProcedimentos() {
    const request = await api.get('recebimento/procedimentos')
    return factory.build(request)
  },

  async getProcedimentosEquipeMedica() {
    const request = await api.get('recebimento/procedimentos')
    return factory.build(request)
  },

  async getValidacaoErros(param: any) {
    const request = await api.get(`calculo/geracao-repasses/${param.geracaoRepasseId}/erros`)
    return factory.build(request)
  },

  async getTransacaoFinanceira() {
    const request = await api.get('calculo/transacao-financeira')
    return factory.build(request)
  },

  async getLocalExecucaoByFontePagadora(parmas: any) {
    let query: string = ''

    if (parmas.hospitalId) {
      query += `&hospitalId=${parmas.hospitalId}`
    }

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/hospital-local-execucao${query}`)
    return factory.build(request)
  },

  async getEquipeMedicaList(params: any) {
    let query: string = ''

    if (params.nome) query += `&nome=${params.nome}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`recebimento/equipe-medica/resumo${query}`)
    return factory.build(request)
  },

  async getCentroDeCusto() {
    const request = await api.get('calculo/centro-de-custo')
    return factory.build(request)
  },

  async getTiposItemDesconsiderado() {
    const request = await api.get('recebimento/listagem-enum/MedicoRecebimentoTipoEnum')
    return factory.build(request)
  },

  async getGrupoRepasseAll() {
    const request = await api.get('recebimento/grupos-repasses')
    return factory.build(request)
  },

  async getSubGrupoRepasse(id: string) {
    const request = await api.get(`recebimento/subgrupos-repasses?grupoRepasseId=${id}`)
    return factory.build(request)
  },

  async getSubGruposRepasseAll() {
    const request = await api.get('recebimento/subgrupos-repasses')
    return factory.build(request)
  },

  async importacaoArquivoRecebimento(form: any, tipoCarga: any, anoMesReferencia?: any, anoMesCompetencia?: any, transacaoUnica?: boolean, naoCarregarPrestadorComCalculo?: boolean) {
    let query: string = ''

    if (tipoCarga) query += `&tipoImportacao=${tipoCarga}`
    if (anoMesReferencia) query += `&MesAnoReferencia=${anoMesReferencia}`
    if (anoMesCompetencia) query += `&MesAnoCompetencia=${anoMesCompetencia}`
    if (transacaoUnica) query += '&transacaoUnica=true'
    if (naoCarregarPrestadorComCalculo) query += `&naoCarregarPrestadorComCalculo=true`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.put(`recebimento/importacao-arquivo${query}`, form)
    return factory.build(request)
  },

  async getDocumentoPrestadorRecebimento(params: any) {
    const request = await api.get(`documento-prestador-recebimento/${params.prestadorRecebimentoId}`)
    return factory.build(request)
  },

  async criarAgrupamentoPrestadorRecebimento(params: any) {
    const request = await api.post('agrupamento', params)
    return factory.build(request)
  },

  async getRelatorioRecebimento(params: any) {
    let query: string = ''

    if (params.grupoRepasseId) query += `&grupoRepasseId=${params.grupoRepasseId}`
    if (params.anoMesReferencia) query += `&anoMesReferencia=${params.anoMesReferencia}`
    if (params.fontePagadoraId) query += `&fontePagadoraId=${params.fontePagadoraId}`
    if (params.situacao) query += `&situacao=${params.situacao}`
    if (params.layoutRelatorio) query += `&layoutRelatorio=${params.layoutRelatorio}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/relatorio-recebimentos${query}`)
    return factory.build(request)
  },

  async atualizarAgrupamento(params: any) {
    const request = await api.put(`agrupamento/${params.id}`, params)
    return factory.build(request)
  },

  async getAgrupamentos(params: any) {
    let query = ''
    if (params.fontePagadoraId) query += `&fontePagadoraId=${params.fontePagadoraId}`
    if (params.anoMesReferencia) query += `&anoMesReferencia=${params.anoMesReferencia}`
    if (params.repassesQueSolicitamNF !== undefined && params.repassesQueSolicitamNF !== null) {
      query += `&repassesQueSolicitamNF=${params.repassesQueSolicitamNF}`
    }
    if (params.periodoCriacaoInicio) query += `&periodoCriacaoInicio=${params.periodoCriacaoInicio}`
    if (params.periodoCriacaoFim) query += `&periodoCriacaoFim=${params.periodoCriacaoFim}`
    if (params.numeroChamado) query += `&numeroChamado=${encodeURIComponent(params.numeroChamado)}`
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    query = query.length > 0 ? `?${query.substring(1)}` : ''
    const request = await api.get(`agrupamento${query}`)
    return factory.build(request)
  },

  async getAgrupamentoDetalhe(params: any) {
    const request = await api.get(`agrupamento/${params.id}`)
    return factory.build(request)
  },

  async downloadAgrupamento(params: any) {
    const request = await api.getBlob(`agrupamento/download/${params.id}`)
    return factory.build(request)
  },

  async deletarDocumentoPrestadorRecebimento(params) {
    const request = await api.delete(`recebimento/deletar-documento-prestador-recebimento/${params.prestadorRecebimentoId}`)
    return factory.build(request)
  },

  async deletarDocumento(params: any) {
    const request = await api.delete(`recebimento/${params.prestadorRecebimentoId}/nota-fiscal?documentoId=${params.documentoId}`)
    return factory.build(request)
  },

  async deletarDocumentoAdicional(params: any) {
    const request = await api.delete(`recebimento/${params.prestadorRecebimentoId}/documento-adicional?documentoId=${params.documentoId}`)
    return factory.build(request)
  },

  async getTabelaPrestadores(params) {
    const request = await api.get(`recebimento/calculo/tabela-preco-prestador?tabelaPrecoId=${params.tabelaPrecoId}`)
    return factory.build(request)
  },

  async getTabelaProfissionais() {
    const request = await api.get('recebimento/calculo/tabela-preco-profissional')
    return factory.build(request)
  },

  async getTabelaProfissionaisById(params: any) {
    const request = await api.get(`recebimento/calculo/tabela-preco-profissional?tabelaPrecoId=${params.tabelaPrecoId}`)
    return factory.build(request)
  },

  async deleteTabelaProfissional(params: any) {
    const request = await api.delete(`recebimento/calculo/tabela-preco-profissional/${params.id}`)
    return factory.build(request)
  },

  async postTabelaProfissional(params: any) {
    const request = await api.put('recebimento/calculo/tabela-preco-profissional', params)
    return factory.build(request)
  },

  async getTabelaOperadora(params: any) {
    const request = await api.get(`recebimento/calculo/tabela-preco-operadora?tabelaPrecoId=${params.tabelaPrecoId}`)
    return factory.build(request)
  },

  async postTabelaOperadora(params: any) {
    const request = await api.post('recebimento/calculo/tabela-preco-operadora', params)
    return factory.build(request)
  },

  async deleteTabelaOperadora(param: any) {
    const request = await api.delete(`recebimento/calculo/tabela-preco-operadora/${param.id}`)
    return factory.build(request)
  },

  async upsertTabelaPrestadores(params) {
    const request = await api.post('recebimento/calculo/tabela-preco-prestador/upsert', params)
    return factory.build(request)
  },

  async deleteTabelaPrestador(param: any) {
    const request = await api.delete(`recebimento/calculo/tabela-preco-prestador/${param.id}`)
    return factory.build(request)
  },

  async deleteTabelaProfissionais(param: any) {
    const request = await api.delete(`recebimento/equipe-medica-profissional/${param.id}`)
    return factory.build(request)
  },

  async postEquipeMedicaProfissional(params: any) {
    const request = await api.post(`recebimento/equipe-medica-profissional`, params)
    return factory.build(request)
  },

  async download(params) {
    const request = await api.get(`recebimento/download/${params.prestadorRecebimentoId}`)
    return factory.build(request)
  },

  async criarUsuario(params: any) {
    const request = await api.post('recebimento/envio-autenticacao', params)
    return factory.build(request)
  },

  async uploadNotaFiscal(params: any) {
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }

    const request = await api.upload(`recebimento/documento-nota-fiscal/${params.prestadorRecebimentoId}`, params.formData, header)
    return factory.build(request)
  },

  async uploadDocumentosAdicionais(params: any) {
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }
    
    const request = await api.upload(`recebimento/documento-adicional/${params.prestadorRecebimentoId}`, params.formData, header)
    return factory.build(request)
  },

  async getTemplateNotificacaoConfig(param: any) {
    const request = await api.get(`recebimento/notificacao-config?Tipo=${param.envioEmailTipo}`)
    return factory.build(request)
  },

  async getDocumentoByPrestadorRecebimentoId(param: any) {
    const request = await api.getBlob(`agrupamento/download/${param.id}`)
    return factory.build(request)
  },

  async getPessoaPrestadorAll(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.limite) query += `&LimiteRegistros=${params.limite}`
      if (params.filtro) query += `&filtro=${params.filtro}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/pessoa-prestador${query}`)
    return factory.build(request)
  },

  async getPrestadores(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.limite) query += `&LimiteRegistros=${params.limite}`
      if (params.filtro) query += `&Filtro=${params.filtro}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/pessoa-prestador${query}`)
    return factory.build(request)
  },

  async getImpostoPrestador(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.prestadorId) query += `&prestadorId=${params.prestadorId.trim()}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/calculo/imposto-grupohospital${query}`)
    return factory.build(request)
  },

  async alterarPrestador(params: any) {
    const request = await api.put(`recebimento/${params.prestadorRecebimentoId}/alterar-prestador/${params.prestadorId}`, params)
    return factory.build(request)
  },

  async getTabelasDeReferencia() {
    const request = await api.get('recebimento/calculo/tabela-preco-procedimento')
    return factory.build(request)
  },

  async getItemsRecebimentoMonitor(param: any) {
    const request = await api.get(`recebimento/${param}/detalhe`)
    return factory.build(request)
  },

  async getRepassesCarregados(param: any) {
    let query = ''

    if (Object.keys(param).length !== 0) {
      if (param.pagina) query += `&pagina=${param.pagina}`
      if (param.qtdPorPagina) query += `&qtdPorPagina=${param.qtdPorPagina}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/importacao-arquivo/${param.importacaoArquivoId}/recebimentos${query}`)
    return factory.build(request)
  },

  async downloadArquivosCargaRemuneracao(id: string) {
    const request = await api.get(`recebimento/arquivo-importacao/${id}`)
    return factory.build(request)
  },

  async downloadCargasGeracao(id: string) {
    const request = await api.get(`recebimento/calculo/geracao-repasse-carga-item/${id}/download`)
    return factory.build(request)
  },

  async getItemsRecebimentoErros(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.pagina) query += `&pagina=${params.pagina}`
      if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
      if (params.recebimentoId) query += `&recebimentoId=${params.recebimentoId}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/erro${query}`)
    return factory.build(request)
  },

  async getItensByTabelaDeReferenciaId(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.pagina) query += `&pagina=${params.pagina}`
      if (params.codigo) query += `&codigo=${params.codigo}`
      if (params.descricao) query += `&descricao=${params.descricao}`
      if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/calculo/tabela-preco/${params.tabelaReferenciaId}/itens${query}`)
    return factory.build(request)
  },

  async createItensByTabelaDeReferenciaId(params: any) {
    const request = await api.post(`recebimento/calculo/tabela-preco/${params.tabelaPrecoId}/itens`, params)
    return factory.build(request)
  },

  async updateItemByTabelaDeReferenciaId(params: any) {
    const request = await api.put(`recebimento/calculo/tabela-preco/${params.tabelaPrecoId}/itens/${params.tabelaPrecoProcedimentoId}`, params)
    return factory.build(request)
  },

  async deleteItemByTabelaDeReferenciaId(params: any) {
    const request = await api.delete(`recebimento/calculo/tabela-preco/${params.tabelaPrecoId}/itens/${params.tabelaPrecoProcedimentoId}`)
    return factory.build(request)
  },

  async getBackofficeProducao(params: any) {
    const { pagina, qtdPorPagina, filtroTexto } = params
    const query: string = `pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 50}&filtroTexto=${filtroTexto || ''}`

    const request = await api.get(`producao?${query}`)
    return factory.build(request)
  },

  async getItensDoRepasse(params: any, id: string) {
    const { pagina, qtdPorPagina, profissional } = params
    
    let query: string = `pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 50}`
    
    if(profissional){
      query += `&profissionalId=${profissional}`;
    }

    const request = await api.get(`recebimento/${id}/itens?${query}`)
    return factory.build(request)
  },

  async liberarRepasses(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.id}/liberar`, params)
    return factory.build(request)
  },

  async liberarRepasseUnico(params: any) {
    const request = await api.put('recebimento/liberar', params)
    return factory.build(request)
  },

  async integrarRepasses(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.geracaoRepasseId}/integrar-his`, params)
    return factory.build(request)
  },

  async recalcularImpostos(params: any) {
    const request = await api.put('recebimento/calculo/prestador-recebimento/recalcular-imposto-aluguel', params)
    return factory.build(request)
  },

  async integrarRepasseUnico(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.geracaoRepasseId}/prestador-recebimentos/${params.prestadorRecebimentoId}/integrar-his`, params)
    return factory.build(request)
  },

  async getTipoCargaDownload(params: any) {
    const request = await api.get(`recebimento/layout-carga/download/${params.tipoCarga}/arquivo/${params.tipoArquivo}`)
    return factory.build(request)
  },

  async descartarRepasses(params: any) {
    const request = await api.put('recebimento', params)
    return factory.build(request)
  },

  async enfileirar(params: any) {
    const request = await api.put('recebimento', params)
    return factory.build(request)
  },

  async desfazerIntegracao(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.prestadorRecebimentoId}/desfazer-integracao`, params)
    return factory.build(request)
  },

  async desfazerLiberacao(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.geracaoRepasseId}/prestador-recebimentos/${params.prestadorRecebimentoId}/desfazer-liberacao`, params)
    return factory.build(request)
  },

  async emitirRelatorio(params: any) {
    const request = await api.get(`calculo/geracao-repasses/${params.geracaoRepasseId}/relatorio`)
    return factory.build(request)
  },

  async filtroDownloadNotaFiscal(params: any) {
    const request = await api.post('nota-fiscal/lote', params)
    return factory.build(request)
  },

  async emitirRelatoriosEmLote(params: any) {
    const request = await api.put('recebimento/relatorio-emissao', params)
    return factory.build(request)
  },

  async emitirRelatorioTabelaPropria(params: any) {
    let query = ''

    if (params.tabelaPrecoId) query += `&TabelaPrecoId=${params.tabelaPrecoId}`

    query = `?${query.substring(1, query.length)}`
    const request = await api.get(`recebimento/relatorio-tabelapropria${query}`)
    return factory.build(request)
  },

  async getEmissaoRelatorio(params: any) {
    const query: string = `${params.relatorioEmissaoId}`

    const request = await api.get(`recebimento/relatorio-emissao/${query}`)
    return factory.build(request)
  },

  async getRecebimentoStatus(params: any) {
    const request = await api.get(`recebimento/${params}/status`)
    return factory.build(request)
  },

  async getUrlArquivo(params: any) {
    const request = await api.get(`recebimentoAtributo/${params}?Nomes=ArquivoUrl&Nomes=NomeArquivo`)
    return factory.build(request)
  },

  async getRelatorioEmitido(params: any) {
    const request = await api.get(`recebimentoAtributo/${params.relatorioEmissaoId}?Nomes=ArquivoUrl&Nomes=NomeArquivo`)
    return factory.build(request)
  },

  async getRelatorioStatus(params: any) {
    const request = await api.get(`recebimento/${params.relatorioEmissaoId}/status`)
    return factory.build(request)
  },

  async getDescarteRepasses(params: any) {
    const request = await api.get(`recebimento/${params.id}/status`)
    return factory.build(request)
  },

  async getRecalculoRepasse(params: any) {
    const request = await api.get(`recebimento/${params.id}/status`)
    return factory.build(request)
  },

  async alterarSituacoesEmLote(params: any) {
    const request = await api.put('recebimento/encerrar-remuneracoes-concluidas', params)
    return factory.build(request)
  },

  async saveAluguelPrestador(params: any) {
    const request = await api.post('calculo/taxa-aluguel-prestador', params)
    return factory.build(request)
  },

  async saveAlterarPontuacaoProfissional(params: any) {
    const request = await api.post('calculo/pontuacao-profissional', params)
    return factory.build(request)
  },

  async saveNovoItemAvulsoRepasse(params: any) {
    const request = await api.post(`recebimento/${params.prestadorRecebimentoId}/itens`, params)
    return factory.build(request)
  },

  async saveInsercaoDeRegistrosEmLoteCalcularRepasse(params: any) {
    const request = await api.post('calculo/anexo-carga-new', params)
    return factory.build(request)
  },

  async putInsercaoDeRegistrosEmLoteCalcularRepasse(params: any) {
    const request = await api.post(`calculo/anexo-carga-lote/${params.id}`, params.formData)
    return factory.build(request)
  },

  async putNovoItemFixoCargaPlanilha(params: any) {
    const request = await api.post(`calculo/anexo-carga-lote-item-fixo/${params.id}`, params.formData)
    return factory.build(request)
  },

  async saveNovoItemAvulsoCalcularRepasse(params: any) {
    const request = await api.post(`calculo/geracao-repasses/${params.geracaoRepasseId}/prestador-recebimentos/${params.prestadorRecebimentoId}/itens/procedimento-calcular`, params)
    return factory.build(request)
  },

  async saveAlterarPrestador(params: any) {
    const request = await api.post(`recebimento/${params.prestadorRecebimentoId}/itens/alterar-profissional`, params)
    return factory.build(request)
  },

  async getHistoricoSituacao(prestadorRecebimentoId: any) {
    const request = await api.get(`/recebimento/${prestadorRecebimentoId}/logs`)
    return factory.build(request)
  },

  async getHistoricoGeracaoRepasse(prestadorRecebimentoId: any) {
    const request = await api.get(`/recebimento/${prestadorRecebimentoId}/logs-status`)
    return factory.build(request)
  },

  async getHistoricoIntegracaoRepasse(item: any) {
    const request = await api.get(`/calculo/geracao-repasses/${item.geracaoRepasseId}/prestador-recebimentos/${item.prestadorRecebimentoId}/logs`)
    return factory.build(request)
  },

  async getValidacaoResultado(params: any) {
    let query = ''
    if (params) query += `&prestadorRecebimentoId=${params}`
    query = query.length > 0 ? `?${query.substring(1, query.length)}` : ''

    const request = await api.get(`nota-fiscal/validacao-resultado${query}`)
    return factory.build(request)
  },

  async getHistoricoCadastroAluguel(params: any) {
    let query: string = ''

    if (params.pagina) {
      query += `&pagina=${params.pagina}`
    }

    if (params.qtdPorPagina) {
      query += `&qtdPorPagina=${params.qtdPorPagina}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`/recebimento/calculo/taxaaluguelprestador/${params.id}/logs?${query}`)
    return factory.build(request)
  },

  async getHistoricoGeracaoItens(params: any) {
    let query: string = ''

    if (params.pagina) {
      query += `&pagina=${params.pagina}`
    }

    if (params.qtdPorPagina) {
      query += `&qtdPorPagina=${params.qtdPorPagina}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`/recebimento/medico-producao-procedimento/${params.medicoProducaoProcedimentoId}/logs?${query}`)
    return factory.build(request)
  },

  async getHistoricoPontuacao(params: any) {
    let query: string = ''

    if (params.pagina) {
      query += `&pagina=${params.pagina}`
    }

    if (params.qtdPorPagina) {
      query += `&qtdPorPagina=${params.qtdPorPagina}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`/calculo/pontuacao/${params.id}/log?${query}`)
    return factory.build(request)
  },

  async getHistoricoPontuacaoProfissional(params: any) {
    let query: string = ''

    if (params.pagina) {
      query += `&pagina=${params.pagina}`
    }

    if (params.qtdPorPagina) {
      query += `&qtdPorPagina=${params.qtdPorPagina}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`/calculo/senioridade-profissional/pontuacao-profissional/${params.id}/log?${query}`)
    return factory.build(request)
  },

  async getItemsCargaRemuneracaoAll(params: any) {
    let query: string = ''

    if (params.pagina) {
      query += `&pagina=${params.pagina}`
    }

    if (params.qtdPorPagina) {
      query += `&qtdPorPagina=${params.qtdPorPagina}`
    }

    if (params.sortBy) {
      query += `&sortBy=${params.sortBy}`
    }

    if (params.periodoDe) {
      query += `&periodoDe=${params.periodoDe}`
    }

    if (params.periodoAte) {
      query += `&periodoAte=${params.periodoAte}`
    }

    if (params.criadoPor) {
      query += `&criadoPor=${params.criadoPor}`
    }

    if (params.tipo) {
      query += `&tipo=${params.tipo}`
    }

    if (params.nomeArquivo) {
      query += `&nomeArquivo=${encodeURIComponent(params.nomeArquivo)}`
    }

    if (params.status) {
      query += `&status=${params.status}`
    }

    if (params.temErro !== null && params.temErro !== undefined && params.temErro !== '') {
      query += `&temErro=${params.temErro}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`recebimento/importacao-arquivo?${query}`)
    return factory.build(request)
  },

  async getCriadoresCarga() {
    const request = await api.get(`recebimento/importacao-arquivo/criadores`)
    return factory.build(request)
  },

  async getItemsDownloadNotasFiscais(params: any) {
    let query: string = ''

    if (params.pagina) {
      query += `&pagina=${params.pagina}`
    }

    if (params.qtdPorPagina) {
      query += `&qtdPorPagina=${params.qtdPorPagina}`
    }

    if (params.anoMesReferencia) {
      query += `&anoMesReferencia=${params.anoMesReferencia}`
    }

    if (params.fontePagadoraId) {
      query += `&fontePagadoraId=${params.fontePagadoraId}`
    }

    if (params.grupoRepasse) {
      query += `&grupoRepasseId=${params.grupoRepasse}`
    }

    if (params.situacao) {
      query += `&situacao=${params.situacao}`
    }

    if (params.geradoPorId) {
      query += `&geradoPorId=${params.geradoPorId}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`nota-fiscal/lote?${query}`)
    return factory.build(request)
  },

  async getUsuariosGeradoresDownloadNotas() {
    const request = await api.get('nota-fiscal/lote/usuarios')
    return factory.build(request)
  },

  async desfazerRepasse(params: any) {
    const request = await api.delete(`recebimento/importacao-arquivo/${params.importacaoArquivoId}`)
    return factory.build(request)
  },

  async getAllItemsSenioridade(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.pagina) query += `&pagina=${params.pagina}`
      if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
      if (params.codigoPontuacaoOuNome) query += `&codigoPontuacaoOuNome=${params.codigoPontuacaoOuNome}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`calculo/senioridade${query}`)
    return factory.build(request)
  },

  async createItemsSenioridade(params: any) {
    const request = await api.post('calculo/senioridade', params)
    return factory.build(request)
  },

  async updateItemsSenioridade(params: any) {
    const request = await api.put(`calculo/senioridade/${params.id}`, params)
    return factory.build(request)
  },

  async deleteItemSenioridade(id: string) {
    const request = await api.delete(`calculo/senioridade/${id}`)
    return factory.build(request)
  },

  async getPontuacaoProfissionalAll(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.profissionalId || params.profissionalId === '') query += `&profissionalId=${params.profissionalId}`
      if (params.filtroValorPontuacao) query += `&FiltroValorPontuacao=${params.filtroValorPontuacao}`
      if (params.equipeProfissionalId) query += `&equipeProfissionalId=${params.equipeProfissionalId}`
      if (params.hospitalId) query += `&hospitalId=${params.hospitalId}`
      if (params.pagina) query += `&pagina=${params.pagina}`
      if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
      query = `?${query.substring(1, query.length)}`
    }
    const request = await api.get(`calculo/pontuacao-profissional${query}`)
    return factory.build(request)
  },

  async criarVinculoRelatorio(params: any) {
    const request = await api.post('relatorio-perfil', params)
    return factory.build(request)
  },

  async criarImpostoPrestador(params: any) {
    const request = await api.post('recebimento/calculo/imposto-prestador', params)
    return factory.build(request)
  },

  async deleteVinculoRelatorio(params: any) {
    const request = await api.delete(`relatorio-perfil/${params.relatorioPerfilId}`)
    return factory.build(request)
  },

  async deleteImpostoPrestador(param: any) {
    const request = await api.delete(`recebimento/calculo/imposto-prestador/${param.id}`)
    return factory.build(request)
  },

  async getVinculosRelatorios(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (!['', null, undefined].includes(params.relatorioId)) query += `&relatorioId=${params.relatorioId}`
      if (!['', null, undefined].includes(params.pessoaId)) query += `&pessoaId=${params.pessoaId}`
      if (!['', null, undefined].includes(params.area)) query += `&area=${params.area}`
      query += `&pagina=${params.pagina || 1}`
      query += `&qtdPorPagina=${params.qtdPorPagina || 50}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`relatorio-perfil${query}`)
    return factory.build(request)
  },

  async getImpostoPrestadores(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.pagina !== undefined && params.pagina !== '') {
        query += `&pagina=${params.pagina}`
      }
      if (params.qtdPorPagina !== undefined && params.qtdPorPagina !== '') {
        query += `&qtdPorPagina=${params.qtdPorPagina}`
      }
      if (params.prestadorId !== undefined && params.prestadorId !== '') {
        query += `&prestadorId=${params.prestadorId}`
      }
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/calculo/imposto-prestador-grupohospital${query}`)
    return factory.build(request)
  },

  async getRelatoriosAll() {
    const request = await api.get('relatorio')
    return factory.build(request)
  },

  async createPontuacaoProfissional(params: any) {
    const request = await api.post('calculo/pontuacao-profissional', params)
    return factory.build(request)
  },

  async updatePontuacaoProfissional(params: any) {
    const request = await api.put(`calculo/pontuacao-profissional/${params.id}`, params)
    return factory.build(request)
  },

  async deletePontuacaoProfissional(id: string) {
    const request = await api.delete(`calculo/pontuacao-profissional/${id}`)
    return factory.build(request)
  },

  async getTaxaAluguelAll(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.prestadorId) query += `&prestadorId=${params.prestadorId}`
      if (params.taxaPadrao === true) query += `&taxaPadrao=${params.taxaPadrao}`
      if (params.pagina) query += `&pagina=${params.pagina}`
      if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`calculo/taxa-aluguel-prestador${query}`)
    return factory.build(request)
  },

  async createTaxaAluguel(params: any) {
    const request = await api.post('calculo/taxa-aluguel-prestador', params)
    return factory.build(request)
  },

  async updateTaxaAluguel(params: any) {
    const request = await api.put(`calculo/taxa-aluguel-prestador/${params.id}`, params)
    return factory.build(request)
  },

  async deleteTaxaAluguel(id: string) {
    const request = await api.delete(`calculo/taxa-aluguel-prestador/${id}`)
    return factory.build(request)
  },

  async fecharGeracaoRepasse(params: any) {
    const request = await api.put('calculo/geracao-repasses/fechamento', params)
    return factory.build(request)
  },

  async getRegistrosValidacao(params: any) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.prestadorId) query += `&prestadorId=${params.prestadorId}`
      if (params.fontePagadoraId) query += `&fontePagadoraId=${params.fontePagadoraId}`
      if (params.nomePaciente) query += `&nomePaciente=${params.nomePaciente}`
      if (params.operadoraId) query += `&operadoraId=${params.operadoraId}`
      if (params.planoOperadoraId) query += `&planoOperadoraId=${params.planoOperadoraId}`
      if (params.profissionalExecutanteId) query += `&profissionalExecutanteId=${params.profissionalExecutanteId}`
      if (params.competenciaFaturamentoAnoMes) query += `&competenciaFaturamentoAnoMes=${params.competenciaFaturamentoAnoMes}`
      if (params.competenciaRepasseAnoMes) query += `&competenciaRepasseAnoMes=${params.competenciaRepasseAnoMes}`
      if (params.codigoHisRegra) query += `&codigoHisRegra=${params.codigoHisRegra}`
      if (params.codigoTuss) query += `&codigoTuss=${params.codigoTuss}`
      if (params.situacao && params.situacao.length > 0) {
        params.situacao.forEach((situacao: string) => {
          query += `&situacao=${situacao}`
        })
      }
      if (params.erros && params.erros.length > 0) {
        params.erros.forEach((erro: string) => {
          query += `&erros=${erro}`
        })
      }
      if (params.pagina) query += `&pagina=${params.pagina}`
      if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`recebimento/calculo/recebimento/recebimento-calculado${query}`)
    return factory.build(request)
  },

  async getProfissionais(params?: any) {
    let query = '';

    if (params.nome) {
      query += `&nome=${encodeURIComponent(params.nome)}`
    }    

    query = query.length > 0 ? `?${query.substring(1, query.length)}` : ''
    
    const request = await api.get(`recebimento/pessoa-profissional-executante${query}`)
    return factory.build(request)
  },

  async getProfissionaisExecutantesByGeracao(params: any) {
    const query = params.nome ? `?nome=${params.nome}` : ''
    const request = await api.get(`calculo/geracao-repasses/${params.geracaoRepasseId}/profissionais-executantes${query}`)
    return factory.build(request)
  },

  async getAllProfissionais(params: any) {
    const request = await api.get(`calculo/geracao-repasses/${params.geracaoRepasseId}/pessoa-profissional`)
    return factory.build(request)
  },

  async getPrestadoresRepasse(params: any) {
    let query = ''

    if (params.fontePagadoraId) query += `&fontePagadoraId=${params.fontePagadoraId}`
    if (params.profissionalId) query += `&profissionalId=${params.profissionalId}`

    query = `?${query.substring(1, query.length)}`

    const request = await api.get(`contrato/consulta-pelo-profissional-fontepagadora${query}`)
    return factory.build(request)
  },

  async getFuncoesProfissionalExecutante() {
    const request = await api.get('recebimento/funcao')
    return factory.build(request)
  },

  async getPlanosRepasse(params: any) {
    const request = await api.get(`convenios/${params.convenioId}/planos?paginar=false`)
    return factory.build(request)
  },

  async getViasAcesso() {
    const request = await api.get('recebimento/via-acesso')
    return factory.build(request)
  },

  async getConveniosRepasse(params: any) {
    let query: string = ''

    if (Object.keys(params).length !== 0) {
      if (params.nome) query += `&nome=${params.nome}`
      query = `?${query.substring(1, query.length)}`
    }

    if (query.length === 1) query = ''
    const request = await api.get(`recebimento/convenio${query}`)
    return factory.build(request)
  },

  async getMotivoInclusao(idGrupoHospital?: string) {
    let query = ''

    if (idGrupoHospital) {
      query += `&IdGrupoHospital=${idGrupoHospital}`
    }

    query = query.length > 0 ? `?${query.substr(1)}` : ''
    
    const request = await api.get(`recebimento/motivo-inclusao-item-recebimento${query}`)
    return factory.build(request)
  },

  async criarMotivoInclusao(payload: {motivo: string, IdGrupoHospital: string}) {
    const request = await api.post('recebimento/motivo-inclusao-item-recebimento', payload)
    return factory.build(request)
  },

  async editarMotivoInclusao(params: {motivo: any, IdGrupoHospital: any, id?: any}){
    const request = await api.put(`recebimento/motivo-inclusao-item-recebimento/${params.id}`, {motivo: params.motivo, IdGrupoHospital: params.IdGrupoHospital })
    return factory.build(request)
  },

  async excluirMotivoInclusao(id: string){
    const request = await api.delete(`recebimento/motivo-inclusao-item-recebimento/${id}`)
    return factory.build(request)
  },

  async getValorDeReferenciaEnum() {
    const request = await api.get('recebimento/listagem-enum/ValorDeReferenciaEnum')
    return factory.build(request)
  },

  async getTipoEnum() {
    const request = await api.get('recebimento/listagem-enum/TipoGeracaoRepasseEnum')
    return factory.build(request)
  },

  async getRegraCalculoAll({ pagina, qtdPorPagina, nomeRegra, ativo, filtraPorEquipeProfissional }: { pagina: number, qtdPorPagina: number, nomeRegra?: string, ativo?: boolean, filtraPorEquipeProfissional?: boolean }) {
    let query: string = `?pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`

    if (nomeRegra) {
      query += `&NomeRegra=${nomeRegra}`
    }

    if (ativo != null) {
      query += `&ativo=${ativo}`
    }

    if (filtraPorEquipeProfissional) {
      query += `&filtraPorEquipeProfissional=${filtraPorEquipeProfissional}`
    }

    const request = await api.get(`recebimento/calculo/regras/regra-calculo${query}`)
    return factory.build(request)
  },

  async getRegrasValorFixo({ fontePagadoraId, prestadorId, profissionalExecutanteId, pagina, qtdPorPagina }: { fontePagadoraId?: string, prestadorId?: string, profissionalExecutanteId?: string, pagina: number, qtdPorPagina: number }) {
    let query: string = `?pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    if (fontePagadoraId) {
      query += `&fontePagadoraId=${fontePagadoraId}`
    }
    if (prestadorId) {
      query += `&prestadorId=${prestadorId}`
    }
    if (profissionalExecutanteId) {
      query += `&profissionalExecutanteId=${profissionalExecutanteId}`
    }

    query = query.length > 0 ? `?${query.substr(1)}` : ''

    const request = await api.get(`recebimento/calculo/regras/valor-fixo${query}`)
    return factory.build(request)
  },

  async getRegrasGarantiaMinima({ pagina, qtdPorPagina }: { pagina: number, qtdPorPagina: number }) {
    const query: string = `?pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    const request = await api.get(`recebimento/calculo/regras/garantia-minima-global${query}`)
    return factory.build(request)
  },

  async getRegrasAgendaGarantiaMinima({ pagina, qtdPorPagina, nomeRegra, profissionalId, estabelecimentoId }: { pagina: number, qtdPorPagina: number, nomeRegra?: string, profissionalId?: string, estabelecimentoId?: string }) {
    let query: string = `?pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`

    if (nomeRegra) {
      query += `&Nome=${encodeURIComponent(nomeRegra)}`
    }

    if (profissionalId) {
      query += `&ProfissionalId=${encodeURIComponent(profissionalId)}`
    }

    if (estabelecimentoId) {
      query += `&EstabelecimentoId=${encodeURIComponent(estabelecimentoId)}`
    }

    const request = await api.get(`recebimento/calculo/regras/agenda-garantia-minima${query}`)
    return factory.build(request)
  },

  async salvarRegra(params: any) {
    const request = await api.put('recebimento/calculo/regras/agenda-garantia-minima', params)
    return factory.build(request)
  },

  async deleteRegra(params: any) {
    const request = await api.delete(`recebimento/calculo/regras/agenda-garantia-minima/${params.id}`)
    return factory.build(request)
  },

  async deleteRegraTeto(params: any) {
    const request = await api.delete(`recebimento/calculo/regras/calculo-teto-global/${params.id}`)
    return factory.build(request)
  },

  async getRegrasTeto(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1)}` : ''
    const request = await api.get(`recebimento/calculo/regras/calculo-teto-global${query}`)
    return factory.build(request)
  },

  async salvarDescarte(params: any) {
    const request = await api.put('recebimento/calculo/regras/agenda-garantia-minima/descarte-procedimento', params)
    return factory.build(request)
  },

  async deleteDescarte(params: any) {
    const request = await api.delete(`recebimento/calculo/regras/agenda-garantia-minima/descarte-procedimento/${params.id}`)
    return factory.build(request)
  },

  async getDescartesProcedimentosRegrasAgendaGarantiaMinimaById(params: any) {
    let query = ''
    
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1)}` : ''
    const request = await api.get(`recebimento/calculo/regras/agenda-garantia-minima/${params.regraAgendaGarantiaMinimaId}/procedimentos-descartados${query}`)
    return factory.build(request)
  },

  async getRegrasGestao(params: any) {
    let query = ''

    if (params.pagina) query += `&Pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&QtdPorPagina=${params.qtdPorPagina}`
    if (params.fontePagadoraId) query += `&FontePagadoraId=${params.fontePagadoraId}`
    if (params.localExecucaoId) query += `&LocalExecucaoId=${params.localExecucaoId}`
    if (params.gestorId) query += `&GestorId=${params.gestorId}`
    if (params.tipoCalculo) query += `&tipoCalculo=${params.tipoCalculo}`

    query = query.length > 0 ? `?${query.substr(1)}` : ''

    const request = await api.get(`recebimento/calculo/regras/calculo-gestor${query}`)
    return factory.build(request)
  },

  async deleteRegraGarantiaMinima(param: any) {
    const request = await api.delete(`recebimento/calculo/regras/garantia-minima-global/${param.id}`)
    return factory.build(request)
  },

  async getRegraCalculoById(regraCalculoId: string) {
    const request = await api.get(`recebimento/calculo/regras/regra-calculo/${regraCalculoId}`)
    return factory.build(request)
  },

  async deleteRegraCalculoValorFixo(regraCalculoId: string) {
    const request = await api.delete(`recebimento/calculo/regras/valor-fixo/${regraCalculoId}`)
    return factory.build(request)
  },

  async deleteRegraGestao(idCalculoGestor: string) {
    const request = await api.delete(`recebimento/calculo/regras/calculo-gestor/${idCalculoGestor}`)
    return factory.build(request)
  },

  async upsertRegraCalculo(params: any) {
    const request = await api.put('recebimento/calculo/regras/regra-calculo', params)
    return factory.build(request)
  },

  async getPrestadoresContratoByRegraCalculoId({ prestadorId, regraCalculoId }: { prestadorId?: string, regraCalculoId: string }) {
    const request = await api.get(`recebimento/calculo/regras/${regraCalculoId}/contratos/prestadores${prestadorId ? `?prestadorId=${prestadorId}` : ''}`)
    return factory.build(request)
  },

  async getRegraCalculoContratoAll({ prestadorId, regraCalculoId, pagina, qtdPorPagina }: { prestadorId: string, regraCalculoId: string, pagina: number, qtdPorPagina: number }) {
    const query: string = `?pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}${prestadorId ? `&prestadorId=${prestadorId}` : ''}`
    const request = await api.get(`recebimento/calculo/regras/${regraCalculoId}/contratos${query}`)
    return factory.build(request)
  },

  async postRegraCalculoContrato({ regraDeCalculoId, contratosId }: {regraDeCalculoId: string, contratosId: string[] }) {
    const request = await api.post(`recebimento/calculo/regras/${regraDeCalculoId}/contratos`, { regraDeCalculoId, contratosId })
    return factory.build(request)
  },

  async deleteRegraCalculoContrato({ regraCalculoId, contratoId }: { regraCalculoId: string, contratoId: string }) {
    const request = await api.delete(`recebimento/calculo/regras/${regraCalculoId}/contratos/${contratoId}`)
    return factory.build(request)
  },

  async getPrestadorContratoCliente(nome: string = '') {
    const request = await api.get(`recebimento/pessoa-prestador-com-contrato${nome ? `?nome=${nome}` : ''}`)
    return factory.build(request)
  },

  async getProfissionalContratoCliente(nome: string = '') {
    const request = await api.get(`recebimento/pessoa-profissional-com-contrato${nome ? `?nome=${nome}` : ''}`)
    return factory.build(request)
  },

  async getContratoByPrestador({ prestadorId, cnpjPrestador, cpfProfissional, profissionalId }: {prestadorId?: string; cnpjPrestador?: string; cpfProfissional?: string; profissionalId?: string }) {
    const query: string = `?prestadorId=${prestadorId || ''}&cnpjPrestador=${cnpjPrestador || ''}&cpfProfissional=${cpfProfissional}&profissionalId=${profissionalId}`
    const request = await api.get(`contrato/consulta-pelo-prestador${query}`)
    return factory.build(request)
  },

  async getRegraCalculoOperadoraAll({ regraCalculoId, pagina, qtdPorPagina }: { regraCalculoId: string, pagina: number, qtdPorPagina: number }) {
    const query: string = `?pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    const request = await api.get(`recebimento/calculo/regras/${regraCalculoId}/operadoras${query}`)
    return factory.build(request)
  },

  async getLocalExecucaoByRegraCalculoId(params: any) {
    const query: string = `?pagina=${params.pagina || 1}&qtdPorPagina=${params.qtdPorPagina || 25}`
    const request = await api.get(`recebimento/calculo/regras/${params.regraCalculoId}/local-execucao${query}`)
    return factory.build(request)
  },

  async getSetorAtendimentoByRegraCalculoId(params: any) {
    const request = await api.get(`recebimento/calculo/regras/${params.regraCalculoId}/setor-atendimento`)
    return factory.build(request)
  },

  async getProcedimentosAll(params: any) {
    const query: string = `?pagina=${params.pagina || 1}&qtdPorPagina=${params.qtdPorPagina || 25}`
    const request = await api.get(`recebimento/calculo/regras/${params.procedimentoId}/procedimentos${query}`)
    return factory.build(request)
  },

  async getProcedimentoCompartilhadoAll(params: any) {
    const query: string = `?pagina=${params.pagina || 1}&qtdPorPagina=${params.qtdPorPagina || 25}`
    const request = await api.get(`recebimento/calculo/regra-calculo/${params.regraCalculoId}/procedimento-compartilhado${query}`)
    return factory.build(request)
  },

  async getPlanoAll(params: any) {
    const query: string = `?pagina=${params.pagina || 1}&qtdPorPagina=${params.qtdPorPagina || 25}`
    const request = await api.get(`recebimento/calculo/regras/${params.regraCalculoId}/planos${query}`)
    return factory.build(request)
  },

  async getPlanosAbrangencia() {
    const request = await api.get('recebimento/calculo/regras/plano/abrangencias')
    return factory.build(request)
  },

  async getFiltroPorProcedimentoList(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/regras/${params.regraCalculoId}/filtro-procedimento${query}`)
    return factory.build(request)
  },

  async deleteFiltroPorProcedimento(params: any) {
    const request = await api.delete(`recebimento/calculo/regras/${params.regraCalculoId}/filtro-procedimento/${params.filtroProcedimentoId}`)
    return factory.build(request)
  },

  async postFiltroPorProcedimento(params: any, regraCalculoId: string) {
    const request = await api.post(`recebimento/calculo/regras/${regraCalculoId}/filtro-procedimento`, params)
    return factory.build(request)
  },

  async getProcedimentosRegra(params: any) {
    const request = await api.get(`recebimento/procedimentos?filtro=${params}`)
    return factory.build(request)
  },

  async getFuncoesProcedimento() {
    const request = await api.get('recebimento/listagem-enum/FuncaoEnum')
    return factory.build(request)
  },

  async getValorReferenciaTipos() {
    const request = await api.get('recebimento/listagem-enum/ValorDeReferenciaTipoEnum ')
    return factory.build(request)
  },

  async getValorReferenciaTeto() {
    const request = await api.get('recebimento/listagem-enum/ValorReferenciaTetoGlobalEnum')
    return factory.build(request)
  },

  async getTipoProducao() {
    const request = await api.get('recebimento/listagem-enum/TipoProducaoEnum')
    return factory.build(request)
  },

  async getTipos() {
    const request = await api.get('recebimento/listagem-enum/TipoRegraCalculoProcedimentoCompartilhadoEnum ')
    return factory.build(request)
  },

  async getValoresReferencia() {
    const request = await api.get('recebimento/listagem-enum/ValorReferenciaProcedimentoCompartilhadoEnum ')
    return factory.build(request)
  },

  async addProcedimentos(params: any) {
    const request = await api.post(`recebimento/calculo/regras/${params.regraCalculoId}/procedimentos`, params)
    return factory.build(request)
  },

  async addPlano(params: any) {
    const request = await api.put(`recebimento/calculo/regras/${params.regraCalculoId}/planos`, params)
    return factory.build(request)
  },

  async getFontesPagadoras() {
    const request = await api.get('recebimento/fontes-pagadoras')
    return factory.build(request)
  },

  async getPeriodos() {
    const request = await api.get('recebimento/listagem-enum/PeriodoEnum')
    return factory.build(request)
  },

  async getHospitaisGarantiaMinimaGlobal(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/regras/garantia-minima-global/${params.id}/hospital${query}`)
    return factory.build(request)
  },

  async deleteHospitalGarantiaMinimaGlobal(params: any) {
    const request = await api.delete(`recebimento/calculo/regras/garantia-minima-global/hospital/${params.id}`)
    return factory.build(request)
  },

  async getAllProcedimentosVinculados(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/agenda-garantia-minima-periodo-procedimento-calcular/${params.agendaGarantiaMinimaPeriodoId}${query}`)
    return factory.build(request)
  },

  async addProcedimentoVinculado(params: any) {
    const response = await api.post(`recebimento/calculo/agenda-garantia-minima-periodo-procedimento-calcular`, params)
    return factory.build(response)
  },

  async addHospitalGarantiaMinimaGlobal(params: any) {
    const request = await api.post('/recebimento/calculo/regras/garantia-minima-global/hospital', params)
    return factory.build(request)
  },

  async addProcedimentoCompartilhado(params: any) {
    const request = await api.put(`recebimento/calculo/regra-calculo/${params.regraCalculoId}/procedimento-compartilhado`, params)
    return factory.build(request)
  },

  async addValorFixo(params: any) {
    const request = await api.put('recebimento/calculo/regras/valor-fixo', params)
    return factory.build(request)
  },

  async addRegraGestao(params: any) {
    const request = await api.put('recebimento/calculo/regras/calculo-gestor', params)
    return factory.build(request)
  },

  async addRegraTeto(params: any) {
    const request = await api.put('recebimento/calculo/regras/calculo-teto-global', params)
    return factory.build(request)
  },

  async addGarantiaMinima(params: any) {
    const request = await api.put('/recebimento/calculo/regras/garantia-minima-global', params)
    return factory.build(request)
  },

  async removeProcedimentoRegra(procedimentoId: string) {
    const request = await api.delete(`recebimento/calculo/regras/${procedimentoId}/procedimentos`)
    return factory.build(request)
  },

  async removeProcedimentoCompartilhado(params: any) {
    const request = await api.delete(`recebimento/calculo/regra-calculo/${params.id}/procedimento-compartilhado/${params.regraCalculoId}`)
    return factory.build(request)
  },

  async removeProcedimentoVinculado(params: any) {
    const request = await api.delete(`recebimento/calculo/agenda-garantia-minima-periodo/${params.agendaGarantiaMinimaId}/procedimento-calcular/${params.procedimentoId}`)
    return factory.build(request)
  },

  async removePlanoRegra(params: any) {
    const request = await api.delete(`recebimento/calculo/regras/${params.regraCalculoId}/planos/${params.regraCalculoPlanoId}`)
    return factory.build(request)
  },

  async addRegraCalculoOperadora(params: any) {
    const request = await api.post(`recebimento/calculo/regras/${params.regraCalculoId}/operadoras`, params)
    return factory.build(request)
  },

  async removeRegraCalculoOperadora(regraCalculoOperadoraId: string) {
    const request = await api.delete(`recebimento/calculo/regras/operadoras/${regraCalculoOperadoraId}`)
    return factory.build(request)
  },

  async addRegraLocalExecucao(params: any) {
    const request = await api.post(`recebimento/calculo/regras/${params.regraCalculoId}/local-execucao`, params)
    return factory.build(request)
  },

  async addRegraSetorAtendimento(params: any) {
    const request = await api.post(`recebimento/calculo/regras/${params.regraCalculoId}/setor-atendimento`, params)
    return factory.build(request)
  },

  async removeLocalExecucao(regraId: any) {
    const request = await api.delete(`recebimento/calculo/regras/local-execucao/${regraId}`)
    return factory.build(request)
  },

  async removeSetorAtendimento(regraId: any) {
    const request = await api.delete(`recebimento/calculo/regras/setor-atendimento/${regraId}`)
    return factory.build(request)
  },

  async getLocaisExecucaoList(params?: any ) {
    let query = ''

    if(params && params.nomeLocalExecucao) query += `&nomeLocalExecucao=${params.nomeLocalExecucao}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`recebimento/hospital-local-execucao${query}`)
    
    return factory.build(request)
  },

  async getSetorAtendimentoList(params: any = {}) {
    let query = ''

    if (params.descricao) query += `&descricao=${encodeURIComponent(String(params.descricao).trim())}`
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`recebimento/setor-atendimento${query}`)
    return factory.build(request)
  },

  async getClassificacaoOperadoraAll() {
    const request = await api.get('recebimento/operadora/classificacao')
    return factory.build(request)
  },

  async getRegraCalculoProcedimentoDescartarAll({ regraCalculoId, pagina, qtdPorPagina }: { regraCalculoId: string, pagina: number, qtdPorPagina: number }) {
    const query: string = `?pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    const request = await api.get(`recebimento/calculo/regras/${regraCalculoId}/procedimentos-descartar`)
    return factory.build(request)
  },

  async postRegraCalculoProcedimentoDescartar(params: any) {
    const request = await api.post(`recebimento/calculo/regras/${params.regraCalculoId}/procedimentos-descartar`, params)
    return factory.build(request)
  },

  async removeRegraCalculoProcedimentoDescartar({ regraCalculoId, procedimentoDescartarId }: { regraCalculoId: string, procedimentoDescartarId: string }) {
    const request = await api.delete(`recebimento/calculo/regras/${regraCalculoId}/procedimentos-descartar/${procedimentoDescartarId}`)
    return factory.build(request)
  },

  async getPessoaOperadoraAll(nome: string = '') {
    const request = await api.get(`recebimento/operadora${nome ? `?nome=${nome}` : ''}`)
    return factory.build(request)
  },

  async getItemsRegrasProfissional(params: any) {
    let query: string = ''

    if (Object.keys(params).length !== 0) {
      if (params.codigoHisRegra) query += `&codigoHisRegra=${params.codigoHisRegra}`
      query = `?${query.substring(1, query.length)}`
    }

    if (query.length === 1) query = ''

    const request = await api.get(`recebimento/calculo/regras/regra-profissional${query}`)
    return factory.build(request)
  },

  async getTabelaPrecoAll() {
    const request = await api.get('recebimento/calculo/tabela-preco')
    return factory.build(request)
  },

  async getTabelaPrecoDetails(params: any) {
    let query: string = ''

    if (params.pagina) { query += `&pagina=${params.pagina}` }
    if (params.qtdPorPagina) { query += `&qtdPorPagina=${params.qtdPorPagina}` }
    if (params.equipeProfissionalId) { query += `&equipeProfissionalId=${params.equipeProfissionalId}` }
    if (params.hospitalId) { query += `&hospitalId=${params.hospitalId}` }
    if (params.nome) { query += `&nome=${params.nome}` }

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`recebimento/calculo/tabela-preco-paginado${query}`)
    return factory.build(request)
  },

  async deleteItemTabelaPreco(id: number) {
    const request = await api.delete(`recebimento/calculo/tabela-preco/${id}`)
    return factory.build(request)
  },

  async criarTabelaPreco(params: any) {
    const request = await api.put('recebimento/calculo/tabela-preco', params)
    return factory.build(request)
  },

  async getTabelaPrecoIndice() {
    const request = await api.get('recebimento/calculo/tabela-preco-indice')
    return factory.build(request)
  },

  async getConvenioRegras() {
    const request = await api.get('recebimento/convenio')
    return factory.build(request)
  },

  async getTabelasAMB() {
    const request = await api.get('recebimento/calculo/tabela-amb')
    return factory.build(request)
  },

  async salvarCodigoAmb(params: any) {
    const request = await api.put('recebimento/calculo/producao-procedimento/codigo-amb', params)
    return factory.build(request)
  },

  async updateItemTabelaAmb(params: any) {
    const request = await api.put('recebimento/calculo/tabela-amb-tuss', params)
    return factory.build(request)
  },

  async saveEditTableRules(params: any) {
    const request = await api.put('recebimento/calculo/regras/regra-profissional', params)
    return factory.build(request)
  },

  async deleteItemTabelaAmb(id: string) {
    const request = await api.delete(`recebimento/calculo/tabela-amb-tuss/${id}`)
    return factory.build(request)
  },

  async getItemsTabelaAMB(params: any) {
    let query: string = ''

    if (params.tabelaAmbId) {
      query += `&tabelaAmbId=${params.tabelaAmbId}`
    }

    query = query.substr(1, query.length - 1)
    const request = await api.get(`recebimento/calculo/tabela-amb-tuss?${query}`)
    return factory.build(request)
  },

  async getConvenio() {
    const request = await api.get('recebimento/convenio')
    return factory.build(request)
  },

  async validarRepasses(params: any) {
    const request = await api.put('recebimento/calculo/validar', params)
    return factory.build(request)
  },

  async excluirItemRepasse(params: any) {
    const request = await api.post('recebimento/itens/deletar', params)
    return factory.build(request)
  },

  async getStatusGeracaoRepasse() {
    const request = await api.get('calculo/geracao-repasses/status')
    return factory.build(request)
  },

  async getGrupoHospital() {
    const request = await api.get('usuario/grupo/hospital')
    return factory.build(request)
  },

  async getRelatoriosByFontePagadora(params: any = {}) {
    let query = ''

    if (Object.keys(params).length !== 0) {
      if (params.area) query += `&area=${params.area.trim()}`
      if (params.paginar) query += `&paginar=${params.paginar}`
      query = `?${query.substring(1, query.length)}`
    }

    const request = await api.get(`relatorio/get-all${query}`)
    return factory.build(request)
  },

  async generateRelatorioByFontePagadora(params: any) {
    const { relatorioId, anoMesReferencia, fontePagadoraId } = params
    const request = await api.get(`relatorio/generate?relatorioId=${relatorioId}&anoMesReferencia=${anoMesReferencia}&fontePagadoraId=${fontePagadoraId}`)
    return factory.build(request)
  },

  async generateRelatorioGeracaoRepasse(params: any) {
    const { relatorioId, anoMesReferencia, fontePagadoraId, grupoRepasseId, situacao, layoutRelatorio } = params
    let query = ''

    if (grupoRepasseId) query += `&grupoRepasseId=${grupoRepasseId}`
    if (situacao) query += `&situacao=${situacao}`
    if (layoutRelatorio) query += `&layoutRelatorio=${layoutRelatorio}`
    if (relatorioId) query += `&relatorioId=${relatorioId}`
    if (anoMesReferencia) query += `&anoMesReferencia=${anoMesReferencia}`
    if (fontePagadoraId) query += `&fontePagadoraId=${fontePagadoraId}`
    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`relatorio/generate${query}`)
    return factory.build(request)
  },

  async getBackofficeChatItems(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/chat${query}`)
    return factory.build(request)
  },

  async getChatsInfo(param: any) {
    const request = await api.get(`recebimento/chat/${param}`)
    return factory.build(request)
  },

  async encerrarAtendimento(params: any) {
    const request = await api.put('/remuneracao/chat/encerrar', params)
    return factory.build(request)
  },

  async integrarItensDeGeracaoDeRepasseNoHis(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.geracaoRepasseId}/prestador-recebimentos/integrar-his`, params)
    return factory.build(request)
  },

  async liberarItensDeGeracaoDeRepasseNoHis(params: any) {
    const request = await api.put('recebimento/liberar', params)
    return factory.build(request)
  },

  async getAllGrupoHospital() {
    const request = await api.get('recebimento/grupo-hospital')
    return factory.build(request)
  },

  async getAllGrupoHospitalById(id: string) {
    const request = await api.get(`recebimento/grupo-hospital/${id}`)
    return factory.build(request)
  },

  async getHospitalById(id: string) {
    const request = await api.get(`recebimento/hospital/${id}`)
    return factory.build(request)
  },

  async getGrupoRepasse(params: any) {
    const request = await api.get(`recebimento/grupo-repasse-hospital?grupoHospitalId=${params.grupoHospitalId}&hospitalId=${params.hospitalId}`)
    return factory.build(request)
  },

  async deleteGrupoRepasse(params: any) {
    const request = await api.delete(`recebimento/grupo-repasse-hospital/${params.grupoRepasseId}/${params.hospitalId}`)
    return factory.build(request)
  },

  async addgrupoRepasse(params: any) {
    const request = await api.post('recebimento/grupo-repasse-hospital', params)
    return factory.build(request)
  },

  async getHospitaisPorGrupo(id: string) {
    const request = await api.get(`recebimento/${id}/hospitais`)
    return factory.build(request)
  },

  async getAllGrupoRepasses() {
    const request = await api.get('recebimento/admin/grupos-repasses')
    return factory.build(request)
  },

  async getTipoEmpresasMedicas() {
    const request = await api.get('recebimento/listagem-enum/TipoEndereco')
    return factory.build(request)
  },

  async getModoUploadItems() {
    const request = await api.get('recebimento/listagem-enum/NotaFiscalModoUploadEnum')
    return factory.build(request)
  },

  async getAllTipoCarga() {
    const request = await api.get('recebimento/listagem-enum/TipoLayoutCarga')
    return factory.build(request)
  },

  async getAllTipoDisparo() {
    const request = await api.get('recebimento/listagem-enum/CalculoModoDisparoEnum')
    return factory.build(request)
  },

  async getAllCargaRegraResponsavelRepasse() {
    const request = await api.get('recebimento/listagem-enum/CargaRegraResponsavelRepasseEnum')
    return factory.build(request)
  },

  async getAllCargaRepasseArquivoModoAgrupamento() {
    const request = await api.get('recebimento/listagem-enum/CargaRepasseArquivoModoAgrupamentoEnum')
    return factory.build(request)
  },

  async updateGrupoHospital(params: any) {
    const request = await api.put('recebimento/grupo-hospital', params)
    return factory.build(request)
  },

  async createGrupoHospital(params: any) {
    const request = await api.put('recebimento/grupo-hospital', params)
    return factory.build(request)
  },

  async createHospital(params: any) {
    const request = await api.post('recebimento/hospital', params)
    return factory.build(request)
  },

  async updateHospital(params: any) {
    const request = await api.put(`recebimento/hospital/${params.id}`, params)
    return factory.build(request)
  },

  async getAllFeriados(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/feriado${query}`)
    return factory.build(request)
  },

  async getAllAgendaGarantiaMinimaPeriodo(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.prestadorId) query += `&prestadorId=${params.prestadorId}`
    if (params.profissionalId) query += `&profissionalId=${params.profissionalId}`
    if (params.estabelecimentoId) query += `&estabelecimentoId=${params.estabelecimentoId}`
    if (params.de) query += `&de=${params.de}`
    if (params.ate) query += `&ate=${params.ate}`
    if (params.periodo) query += `&periodo=${params.periodo}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/agenda-garantia-minima-periodo${query}`)
    return factory.build(request)
  },

  async getAgendaGarantiaMinimaPeriodoById(id: string) {
    const request = await api.get(`recebimento/calculo/agenda-garantia-minima-periodo/${id}`)
    return factory.build(request)
  },

  async deleteItemFeriado(param: any) {
    const request = await api.delete(`recebimento/feriado/${param.id}`)
    return factory.build(request)
  },

  async deleteItemAgendaGarantiaMinima(param: any) {
    const request = await api.delete(`recebimento/calculo/agenda-garantia-minima-periodo/${param.id}`)
    return factory.build(request)
  },

  async createItemFeriado(params: any) {
    const request = await api.post('recebimento/feriado', params)
    return factory.build(request)
  },

  async updateItemFeriado(params: any) {
    const request = await api.post('recebimento/feriado', params)
    return factory.build(request)
  },

  async updateItemAgendaGarantiaMinimaPeriodo(params: any) {
    const request = await api.put('recebimento/calculo/agenda-garantia-minima-periodo', params)
    return factory.build(request)
  },

  async getIndicacoesAll(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/calculo-indicacao-medica${query}`)
    return factory.build(request)
  },

  async addIndicacao(params: any) {
    const request = await api.post('recebimento/calculo/calculo-indicacao-medica/upsert', params)
    return factory.build(request)
  },

  async deleteIndicacao(params: any) {
    const request = await api.delete(`recebimento/calculo/calculo-indicacao-medica/${params.id}`)
    return factory.build(request)
  },

  async getListaPrestadores(nome: string = '') {
    let query = ''

    if (nome) query += `&nome=${nome}`
    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/regras/garantia-minima-global/prestador${query}`)
    return factory.build(request)
  },

  async getListaTeto() {
    const request = await api.get('recebimento/calculo/regras/calculo-teto-global/regras')
    return factory.build(request)
  },

  async getPreviaTeto(parmas: any) {
    let query = ''

    if (parmas.regraCalculoTetoGlobalId) query += `&regraCalculoTetoGlobalId=${parmas.regraCalculoTetoGlobalId}`
    if (parmas.mesAnoCompetencia) query += `&mesAnoCompetencia=${parmas.mesAnoCompetencia}`
    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/regras/calculo-teto-global/previa${query}`)
    return factory.build(request)
  },

  async getCalcularGarantiaMinima(params: any) {
    let query = ''

    if (params.prestadorId) query += `&prestadorId=${params.prestadorId}`
    if (params.mesAnoCompetencia) query += `&mesAnoCompetencia=${params.mesAnoCompetencia}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/regras/garantia-minima-global/calculada${query}`)
    return factory.build(request)
  },

  async calcularGarantiaMinima(params: any) {
    const request = await api.post('recebimento/calculo/regras/garantia-minima-global/calculada', params)
    return factory.build(request)
  },

  async getEquipesProfissionalAll(params: any) {
    let query = ''

    if (params.regraCalculoId) query += `&regraCalculoId=${params.regraCalculoId}`
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/calculo/equipe-profissional${query}`)
    return factory.build(request)
  },

  async getResumoEquipeMedica() {
    const request = await api.get('recebimento/equipe-medica/resumo')
    return factory.build(request)
  },

  async getProfissionaisEquipeMedica(params: any) {
    let query = ''

    if (params.equipeMedicaId || params.id) query += `?equipeMedicaId=${params.equipeMedicaId ? params.equipeMedicaId : params.id}`
    if (params.profissionalNome) query += `&profissionalNome=${params.profissionalNome}`
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`recebimento/equipe-medica-profissional${query}`)
    return factory.build(request)
  },

  async postVinculoEquipeMedica(params: any) {
    const request = await api.post('recebimento/calculo/equipe-profissional', params)
    return factory.build(request)
  },

  async deletarVinculoEquipeMedica(params: number) {
    const request = await api.delete(`recebimento/calculo/equipe-profissional/${params}`)
    return factory.build(request)
  },

  async calcularTeto(params: any) {
    const request = await api.put('recebimento/calculo/regras/calculo-teto-global/calcular', params)
    return factory.build(request)
  },

  async getEquipesAll(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.nome) query += `&nome=${params.nome}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`recebimento/equipe-medica${query}`)
    return factory.build(request)
  },

  async salvarEquipe(params: any) {
    const request = await api.post('recebimento/equipe-medica', params)
    return factory.build(request)
  },

  async deleteEquipeMedica(params: any) {
    const request = await api.delete(`recebimento/equipe-medica/${params.id}`)
    return factory.build(request)
  },

  async getRegrasEquipeMedica() {
    const request = await api.get('recebimento/calculo/equipe-profissional')
    return factory.build(request)
  },

  async desmembrarRepassesNegativos(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.geracaoRepasseId}/desmembrar-negativos`, {})
    return factory.build(request)
  },

  async getUsuarios(params: any) {
    let query = ''
    
    if (params.nome) query += `&Nome=${params.nome}`
    if (params.cpf) query += `&Cpf=${params.cpf}`
    if (params.email) query += `&Email=${params.email}`
    if (params.pagina) query += `&Pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&QtdPorPagina=${params.qtdPorPagina}`

    if (query.length > 0) query = `?${query.substr(1, query.length - 1)}`
    
    const request = await api.get(`usuario/remuneracao/consulta${query}`)
    return factory.build(request)
  },

  async getIntegracaoGeralRepasses(params: any) {
    let query = ''

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`integracao-repasse${query}`)
    return factory.build(request)
  },

  async criarIntegracaoRepasse(params: any) {
    const request = await api.post('integracao-repasse/executar', params)
    return factory.build(request)
  },

  async alterarDatas(params: any) {
    const request = await api.put(`calculo/geracao-repasses/${params.geracaoRepasseId}/alterar-datas`, params)
    return factory.build(request)
  },

  async getParametrosAplicacaoTaxaAluguelPrestador(params: any = {}) {
    let query = ''

    if (params.fontePagadoraId) query += `&fontePagadoraId=${encodeURIComponent(params.fontePagadoraId)}`
    if (params.prestadorId) query += `&prestadorId=${encodeURIComponent(params.prestadorId)}`
    if (params.prestador) query += `&prestadorId=${encodeURIComponent(params.prestador)}`
    if (params.pagina) query += `&pagina=${encodeURIComponent(params.pagina)}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${encodeURIComponent(params.qtdPorPagina)}`

    if (query.length > 0) query = `?${query.substr(1, query.length - 1)}`

    const request = await api.get(`calculo/taxa-aluguel-prestador-config${query}`)
    return factory.build(request)
  },

  async createParametroAplicacaoTaxaAluguelPrestador(params: any) {
    const request = await api.post('calculo/taxa-aluguel-prestador-config', params)
    return factory.build(request)
  },

  async updateParametroAplicacaoTaxaAluguelPrestador(params: any, id: string) {
    const request = await api.put(`calculo/taxa-aluguel-prestador-config/${id}`, params)
    return factory.build(request)
  },

  async deleteParametroAplicacaoTaxaAluguelPrestador(id: string) {
    const request = await api.delete(`calculo/taxa-aluguel-prestador-config/${id}`)
    return factory.build(request)
  },

  async getTaxaAluguelPrestadorConfig() {
    const request = await api.get('calculo/taxa-aluguel-prestador-config')
    return factory.build(request)
  },

  async getGruposRepasses() {
    const request = await api.get(`recebimento/grupo-repasse`)
    return factory.build(request)
  },

  async updateGrupoRepasse(params: any) {
    const request = await api.put(`recebimento/grupo-repasse`, params)
    return factory.build(request)
  },

  async getEspecialidadeAll(params: any) {
    let query = ''
    if (params.descricao) query += `&descricao=${params.descricao}`
    if (params.codigoUnico) query += `&codigoUnico=${params.codigoUnico}`
    if (params.hospitalId) query += `&hospitalId=${params.hospitalId}`
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    query = query.length > 0 ? `?${query.substring(1)}` : ''
    const request = await api.get(`especialidade${query}`)
    return factory.build(request)
  },

  async createEspecialidade(params: any) {
    const request = await api.post('especialidade', params)
    return factory.build(request)
  },

  async updateEspecialidade(params: any) {
    const request = await api.put(`especialidade/${params.id}`, params)
    return factory.build(request)
  },

  async deleteEspecialidade(id: string) {
    const request = await api.delete(`especialidade/${id}`)
    return factory.build(request)
  },

  async getSubEspecialidadeAll(params: any) {
    let query = ''
    if (params.especialidadeId) query += `&especialidadeId=${params.especialidadeId}`
    if (params.descricao) query += `&descricao=${params.descricao}`
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    query = query.length > 0 ? `?${query.substring(1)}` : ''
    const request = await api.get(`sub-especialidade${query}`)
    return factory.build(request)
  },

  async createSubEspecialidade(params: any) {
    const request = await api.post('sub-especialidade', params)
    return factory.build(request)
  },

  async updateSubEspecialidade(params: any) {
    const request = await api.put(`sub-especialidade/${params.id}`, params)
    return factory.build(request)
  },

  async deleteSubEspecialidade(id: string) {
    const request = await api.delete(`sub-especialidade/${id}`)
    return factory.build(request)
  },

  async getEspecialidadeProcedimentoAll(params: any) {
    let query = ''
    if (params.especialidadeId) query += `&especialidadeId=${params.especialidadeId}`
    if (params.subEspecialidadeId) query += `&subEspecialidadeId=${params.subEspecialidadeId}`
    if (params.codigoProcedimento) query += `&codigoProcedimento=${params.codigoProcedimento}`
    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    query = query.length > 0 ? `?${query.substring(1)}` : ''
    const request = await api.get(`especialidade-procedimento${query}`)
    return factory.build(request)
  },

  async createEspecialidadeProcedimento(params: any) {
    const request = await api.post('especialidade-procedimento', params)
    return factory.build(request)
  },

  async updateEspecialidadeProcedimento(params: any) {
    const request = await api.put(`especialidade-procedimento/${params.id}`, params)
    return factory.build(request)
  },

  async deleteEspecialidadeProcedimento(id: string) {
    const request = await api.delete(`especialidade-procedimento/${id}`)
    return factory.build(request)
  },

  async getListagemEnum(tipoEnum: string) {
    const request = await api.get(`recebimento/listagem-enum/${tipoEnum}`)
    return factory.build(request)
  },

  async getTransacaoFinanceiraListagem(params: any) {
    let query = `pagina=${params.pagina || 1}&qtdPorPagina=${params.qtdPorPagina || 50}`
    if (params.descricao) query += `&descricao=${encodeURIComponent(params.descricao)}`
    if (params.codigoHis) query += `&codigoHis=${encodeURIComponent(params.codigoHis)}`
    if (params.status) query += `&status=${params.status}`
    if (params.origem) query += `&origem=${params.origem}`
    if (params.periodoCriacaoInicio) query += `&periodoCriacaoInicio=${params.periodoCriacaoInicio}`
    if (params.periodoCriacaoFim) query += `&periodoCriacaoFim=${params.periodoCriacaoFim}`
    const request = await api.get(`calculo/transacao-financeira/listagem?${query}`)
    return factory.build(request)
  },

  async upsertTransacaoFinanceira(params: any) {
    const request = params.id
      ? await api.put(`calculo/transacao-financeira/${params.id}`, params)
      : await api.post('calculo/transacao-financeira', params)
    return factory.build(request)
  },

  async removeTransacaoFinanceira(id: string) {
    const request = await api.delete(`calculo/transacao-financeira/${id}`)
    return factory.build(request)
  },

  async getCentroDeCustoListagem(params: any) {
    let query = `pagina=${params.pagina || 1}&qtdPorPagina=${params.qtdPorPagina || 50}`
    if (params.descricao) query += `&descricao=${encodeURIComponent(params.descricao)}`
    if (params.codigoHis) query += `&codigoHis=${encodeURIComponent(params.codigoHis)}`
    if (params.hospitalId) query += `&hospitalId=${params.hospitalId}`
    if (params.origem) query += `&origem=${params.origem}`
    if (params.periodoCriacaoInicio) query += `&periodoCriacaoInicio=${params.periodoCriacaoInicio}`
    if (params.periodoCriacaoFim) query += `&periodoCriacaoFim=${params.periodoCriacaoFim}`
    const request = await api.get(`calculo/centro-de-custo/listagem?${query}`)
    return factory.build(request)
  },

  async upsertCentroDeCusto(params: any) {
    const request = params.id
      ? await api.put(`calculo/centro-de-custo/${params.id}`, params)
      : await api.post('calculo/centro-de-custo', params)
    return factory.build(request)
  },

  async removeCentroDeCusto(id: string) {
    const request = await api.delete(`calculo/centro-de-custo/${id}`)
    return factory.build(request)
  },

  async getOperadoraHospitalListagem(params: any) {
    let query = `pagina=${params.pagina || 1}&qtdPorPagina=${params.qtdPorPagina || 50}`
    if (params.descricao) query += `&descricao=${encodeURIComponent(params.descricao)}`
    if (params.codigoHis) query += `&codigoHis=${encodeURIComponent(params.codigoHis)}`
    if (params.hospitalId) query += `&hospitalId=${params.hospitalId}`
    if (params.periodoCriacaoInicio) query += `&periodoCriacaoInicio=${params.periodoCriacaoInicio}`
    if (params.periodoCriacaoFim) query += `&periodoCriacaoFim=${params.periodoCriacaoFim}`
    const request = await api.get(`operadora-hospital/listagem?${query}`)
    return factory.build(request)
  },

  async upsertOperadoraHospital(params: any) {
    const request = params.id
      ? await api.put(`operadora-hospital/${params.id}`, params)
      : await api.post('operadora-hospital', params)
    return factory.build(request)
  },

  async removeOperadoraHospital(id: string) {
    const request = await api.delete(`operadora-hospital/${id}`)
    return factory.build(request)
  },
  
  async getProducaoDisponivelResumo(params: { fontePagadoraId: string; prestadorId: string; competenciaFaturamentoAnoMes: string; operadoraId?: string }) {
    let query = `fontePagadoraId=${params.fontePagadoraId}&prestadorId=${params.prestadorId}&competenciaFaturamentoAnoMes=${params.competenciaFaturamentoAnoMes}`
    if (params.operadoraId) query += `&operadoraId=${params.operadoraId}`
    const request = await api.get(`calculo/producao-disponivel/resumo?${query}`)
    return factory.build(request)
  },

  async getAuditLog(params: any) {
    const request = await api.get(`recebimento/audit-log?entityName=${params.entityName}&entityId=${params.entityId}`)
    return factory.build(request)
  },
}

